__turbopack_context__.v({
  "allCookies": "CookieNotice-module-scss-module__vvLqma__allCookies",
  "cookieBanner": "CookieNotice-module-scss-module__vvLqma__cookieBanner",
  "smallCookieBanner": "CookieNotice-module-scss-module__vvLqma__smallCookieBanner",
});
